import React from 'react';
import AuditLogTable from '../components/AuditLogTable';

const AuditLogPage = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <AuditLogTable />
        </div>
    );
};

export default AuditLogPage;
